import React, { Component } from 'react';

import styles from '../TopicDots.module.css';
import { development, production } from '../../../config';

let audioPath = production;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') audioPath = development;

export default class TopicListDots extends Component {
	audioRefs = [];
	topic = this.props.topicID * 1;
	state = {
		currentlyPlayingTopic: this.props.currentlyPlayingTopic,
		playingBlockIndex: this.props.playingBlockIndex,
		playAnimation: this.props.animationRunning,
		topicID: parseInt(this.props.topicID),
		totalDots: (this.topic === 5 || this.topic === 6 || this.topic === 7 || this.topic === 9 || this.topic === 10) ? 4 : 5
	}

	handleClicks = (index) => {
		this.props.setCurrentlyPlayingTopic(this.props.topicID);
		this.props.setPlayingBlockIndex(index);
		if (this.audioRefs[index].paused) {
			this.audioRefs[index].play();
			this.props.setAnimationState(true);
		} else {
			this.audioRefs[index].pause();
			this.props.setAnimationState(false);
		}
	}

	onEnded = () => {
		this.props.setCurrentlyPlayingTopic(null);
		this.props.setPlayingBlockIndex(null);
		this.props.setAnimationState(false);
	}

	getDots = () => {
		const dots = [];

		for (let i = 1; i <= this.state.totalDots; i++) {
			// TODO remove the state condition in the next line maybe? So that the audio files are not loaded again and again
			const audioSrc = `${audioPath}/app-2/T${this.state.topicID}-q${i}.mp3`;       // names of audio files are in the format: T1-q1.mp3, T1-q2.mp3 and so on
			const playAnimation = this.state.currentlyPlayingTopic === this.props.topicID && this.state.playingBlockIndex === i;
			const animationPlayState = this.state.currentlyPlayingTopic === this.props.topicID && this.state.playingBlockIndex === i && this.state.playAnimation;
			const animationStyle = {
				animationName: playAnimation ? 'playMask' : 'none',
				animationDuration: playAnimation ? `${this.audioRefs[i].duration}s` : '0',
				animationPlayState: animationPlayState ? 'running' : 'paused',
			}

			dots.push(
				<div key={'dot-' + i} className={styles.Dot} onClick={() => this.handleClicks(i)}>
					<audio onEnded={() => this.onEnded()} ref={ref => this.audioRefs[i] = ref} >
						<source src={audioSrc} type="audio/mpeg" />
					</audio>
					<div className={styles.DotMask} style={animationStyle} />
				</div>
			);
		}
		return dots;
	}

	componentDidUpdate(prevProps) {
		const stopAudio = stopAll => {
			if (stopAll) {
				for (let i = 1; i <= this.state.totalDots; i++) {
					this.audioRefs[i].pause();
					this.audioRefs[i].currentTime = 0;
				}
			} else {
				for (let i = 1; i <= this.state.totalDots; i++) {
					if (i !== this.props.playingBlockIndex) {
						this.audioRefs[i].pause();
						this.audioRefs[i].currentTime = 0;
					}
				}
			}
		};

		if (prevProps !== this.props) {
			if (prevProps.currentlyPlayingTopic !== this.props.currentlyPlayingTopic) {
				this.setState({ currentlyPlayingTopic: this.props.currentlyPlayingTopic });
			}

			if (prevProps.playingBlockIndex !== this.props.playingBlockIndex) {
				this.setState({ playingBlockIndex: this.props.playingBlockIndex });
			}

			if (this.props.currentlyPlayingTopic !== this.props.topicID) {
				stopAudio(true);    // if stopping all audio dots, we pass true
			} else stopAudio(false);

			if (prevProps.animationRunning !== this.props.animationRunning) {
				this.setState({ playAnimation: this.props.animationRunning });
			}
		}
	}

	render() {
		return (
			<div className={[styles.DotsContainer, 'tooltip-dots-container'].join(' ')}>
				{this.getDots()}
			</div>
		)
	}
}